import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Veronica Ma",
    role: "CEO, Arbor",
    text: "CyberTech Prefects helped us achieve SOC 2 Type II in record time. Their hands-on approach and deep compliance knowledge made the entire process seamless.",
    rating: 5,
  },
  {
    name: "Rahul B",
    role: "CEO, YellowMetal",
    text: "Their DevSecOps integration transformed our CI/CD pipeline. We went from reactive patching to proactive security — a game-changer for our enterprise clients.",
    rating: 5,
  },
  {
    name: "Frances Zelazny",
    role: "CEO, Anonybit",
    text: "Having a fractional CISO from CyberTech Prefects gave us the strategic security leadership we needed during our Series B, without the full-time cost.",
    rating: 5,
  },
];

function TestimonialCard({ testimonial, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.15, duration: 0.5 }}
      data-testid={`testimonial-card-${index}`}
      className="testimonial-card rounded-xl border border-white/5 p-8 hover:border-[#B87333]/20 transition-all duration-300"
    >
      {/* Stars */}
      <div className="flex gap-1 mb-5">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-[#B87333] text-[#B87333]" />
        ))}
      </div>

      {/* Quote */}
      <p className="text-sm text-zinc-300 leading-relaxed mb-6">
        &ldquo;{testimonial.text}&rdquo;
      </p>

      {/* Author */}
      <div>
        <p className="text-sm font-medium text-white">{testimonial.name}</p>
        <p className="text-xs text-zinc-500 mt-1">{testimonial.role}</p>
      </div>
    </motion.div>
  );
}

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0A0A0B]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E5A97A]/80 block mb-4">
            Client Stories
          </span>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-white">
            What Our Clients Say
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <TestimonialCard key={i} testimonial={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
